import React from "react";
import HobbliInfoLayout from "./HobbliInfoLayout";

const Item = ({ q, children }) => <div className="faq-item"><strong>{q}</strong><p>{children}</p></div>;

export default function FAQ() {
  return (
    <HobbliInfoLayout eyebrow="About & Support" title="Frequently Asked Questions" intro="Quick answers to common questions about using Hobbli.">
      <section className="faq-section">
        <h2>General</h2>
        <Item q="What is Hobbli?">Hobbli is a platform for collectors to organize collections, research items, share, connect with other collectors, and enjoy the hobby.</Item>
        <Item q="Is Hobbli free?">Hobbli is currently free to use. Additional features, services, or monetization options may be explored in the future as the platform grows.</Item>
      </section>
      <section className="faq-section">
        <h2>Collections & Items</h2>
        <Item q="How do I add items to my collection?">You can enter item details manually or upload a photo and use Hobbli's identification tools to help populate item information. You can review and edit details before saving.</Item>
      </section>
      <section className="faq-section">
        <h2>Photo Identification</h2>
        <Item q="How does photo identification work?">Upload an item photo and Hobbli will attempt to identify useful details such as the item, set, year, or number. Identification results should always be reviewed before saving.</Item>
        <Item q="Why couldn't Hobbli identify my item?">Image quality, glare, unusual angles, multiple objects, or uncommon items can make identification harder. You can always enter or correct item information manually.</Item>
      </section>
      <section className="faq-section">
        <h2>Buying & Selling</h2>
        <Item q="Can I buy or sell items through Hobbli?">Users can list items for sale and communicate with one another. Hobbli does not currently process payments, shipping, or fulfillment for user-to-user transactions.</Item>
        <Item q="Does Hobbli verify buyers or sellers?">Not currently. Users are responsible for evaluating one another and choosing appropriate payment and transaction protections.</Item>
        <Item q="Does Hobbli take selling fees?">Hobbli does not currently charge fees for user listings or sales. This may change as marketplace functionality evolves.</Item>
        <Item q="How do I pay another user?">Payment methods and arrangements are handled between the buyer and seller. Hobbli is not currently involved in payment processing or fulfillment.</Item>
      </section>
      <section className="faq-section">
        <h2>Account & Support</h2>
        <Item q="What if I forget my password?">Use the Reset Password option on the login page to request a reset link.</Item>
        <Item q="Can I delete my account?">Yes. Contact Hobbli through the support form for assistance with an account deletion request.</Item>
        <Item q="How do I contact support?">Open Contact & Support from this section and send us a message with the relevant details.</Item>
      </section>
    </HobbliInfoLayout>
  );
}
